// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonSearchFilter_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.9908 2.15479C14.8385 4.5658 14.3818 8.01819 11.9707 9.86585C10.501 10.9921 8.64439 11.2621 7.00015 10.7551V10.4142L8.46257 8.95179C9.24767 8.98094 10.0472 8.74727 10.7195 8.23206C12.2538 7.05628 12.5444 4.85938 11.3686 3.32508C10.1929 1.79077 7.99595 1.50025 6.46165 2.67603C5.99028 3.03725 5.6363 3.49485 5.40617 4H3.33352C3.64487 2.89856 4.30144 1.88455 5.27983 1.13477C7.69084 -0.712888 11.1432 -0.256223 12.9908 2.15479Z" class="svg-bg"/>
  <path d="M6 10.3348C5.99995 10.3348 6.00005 10.3348 6 10.3348V15L4 14V10L0 6 1 5H9L10 6 7.29427 8.70573C7.29431 8.70574 7.29424 8.70571 7.29427 8.70573L6.00015 10 6 10.3348ZM13.7525 9.72913 11.3713 11.554 15.2064 14.9143 16.0001 14.306 13.7525 9.72913Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.83562 4.34315C8.95981 1.21895 14.0251 1.21895 17.1493 4.34315 20.2735 7.46734 20.2735 12.5327 17.1493 15.6569 14.9447 17.8615 11.7735 18.5104 8.99991 17.6036V15.4595C11.2129 16.4694 13.9137 16.0637 15.7349 14.2425 18.0781 11.8993 18.0781 8.10033 15.7349 5.75719 13.3918 3.41404 9.5928 3.41404 7.24966 5.75719 6.86957 6.13727 6.55114 6.55566 6.29437 6.99993H4.07407C4.46459 6.03302 5.05177 5.12699 5.83562 4.34315ZM19.9776 15.6567 17.1492 18.4851 22.099 22.0206 23.5132 20.6064 19.9776 15.6567Z" class="svg-bg"/>
  <path d="M11 9H1L0 10L5 15L5 20L7 21L7 15L12 10L11 9Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonSearchFilter is a generated icon component.
 */
let IconCommonSearchFilter = IconCommonSearchFilter_1 = class IconCommonSearchFilter extends IconBaseElement {
    render() {
        return html `${IconCommonSearchFilter_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonSearchFilter.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonSearchFilter = IconCommonSearchFilter_1 = __decorate([
    customElement('zui-icon-common-search-filter')
], IconCommonSearchFilter);
export { IconCommonSearchFilter };
